import React from 'react'

// Material-UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import { IoIosList, IoMdCheckboxOutline } from 'react-icons/io'
import './WhoLivesHereItem.scss'
import { useErrorSnackBarContext } from '../../ErrorSnackBar/ErrorSnackBarContext'
import Interceptor from '../../../../Services/serviceBase.interceptor'
const splitLineJumpFromString = (longString) => {
  const arrayWithNoBreaks = longString.split('\n')
  return arrayWithNoBreaks.filter((string) => string)
}

function WhoLivesHereItem({ whoLivesHereEntity }) {
  const { errorSnackBarActions } = useErrorSnackBarContext()
  Interceptor.interceptor(errorSnackBarActions)

  let medicationDescriptionList = []
  let medLocations = []
  if (whoLivesHereEntity.requiresMedication?.isChecked) {
    if (whoLivesHereEntity.requiresMedication.description?.length) {
      medicationDescriptionList = splitLineJumpFromString(
        whoLivesHereEntity.requiresMedication.description
      )
    }
  }
  if (whoLivesHereEntity.requiresMedicationIfEvacuated?.location?.length) {
    medLocations = splitLineJumpFromString(
      whoLivesHereEntity.requiresMedicationIfEvacuated.location
    )
  }

  return (
    <div className="App WhoLivesHereItem">
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid size={12}></Grid>
          <Grid size={12}>
            <form noValidate autoComplete="off">
              <Grid container>
                <Grid size={12} className="container-field">
                  {whoLivesHereEntity.name ? (
                    <Grid>
                      <label className="main-title-label">Name:</label>{' '}
                      <label> {whoLivesHereEntity.name} </label>
                    </Grid>
                  ) : null}
                  {whoLivesHereEntity.age ? (
                    <Grid>
                      <label className="main-title-label">Age:</label>{' '}
                      <label> {whoLivesHereEntity.age} </label>
                    </Grid>
                  ) : null}
                  {whoLivesHereEntity.gender !== null ? (
                    <Grid>
                      <label className="main-title-label">Gender:</label>
                      <label>
                        {' '}
                        {whoLivesHereEntity.gender === 0
                          ? 'female'
                          : whoLivesHereEntity.gender === 1
                            ? 'male'
                            : whoLivesHereEntity.genderOther === null
                              ? 'Other'
                              : whoLivesHereEntity.genderOther}{' '}
                      </label>
                    </Grid>
                  ) : null}

                  {whoLivesHereEntity.bedroomLocation &&
                  (whoLivesHereEntity.bedroomLocation.floor !== null ||
                    whoLivesHereEntity.bedroomLocation.location !== null) ? (
                    <Grid>
                      <label className="main-title-label">Normal bedroom located where: </label>
                      <Grid className="container-field">
                        {whoLivesHereEntity.bedroomLocation.floor ? (
                          <Grid>
                            <label>Floor: {whoLivesHereEntity.bedroomLocation.floor} </label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.bedroomLocation.location ? (
                          <Grid>
                            <label>Location: {whoLivesHereEntity.bedroomLocation.location} </label>
                          </Grid>
                        ) : null}
                      </Grid>
                    </Grid>
                  ) : null}

                  {whoLivesHereEntity.specialAssistanceEvacuating &&
                  whoLivesHereEntity.specialAssistanceEvacuating.isChecked ? (
                    <Grid>
                      {whoLivesHereEntity.specialAssistanceEvacuating &&
                      whoLivesHereEntity.specialAssistanceEvacuating.isChecked ? (
                        <Grid>
                          <label className="main-title-label">
                            May need special assistance evacuating or following instructions:{' '}
                          </label>
                          <label>Yes</label>
                        </Grid>
                      ) : null}
                      <Grid className="container-field">
                        {whoLivesHereEntity.specialAssistanceEvacuating.youngChild ? (
                          <Grid>
                            {' '}
                            {<IoMdCheckboxOutline />}
                            <label>Young child</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.sightImpaired ? (
                          <Grid>
                            {' '}
                            {<IoMdCheckboxOutline />}
                            <label>Sight impaired</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.speechImpaired ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>Speech impaired</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.physicallyImpaired ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>Physically impaired</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.greaterThan300Pounds ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>Greater than 300 pounds</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.bedridden ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>Bedridden</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.mentallyMemoryImpaired ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>Mentally/memory impaired</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.dementiaAlzheimers ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>Dementia/Alzheimer’s</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.onDialysis ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>On Dialysis</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating.onOxygen ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>On oxygen</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.specialAssistanceEvacuating
                          .requiresConstantSkilledNursingCare ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label>Requires constant skilled nursing care</label>{' '}
                          </Grid>
                        ) : null}

                        {whoLivesHereEntity.specialAssistanceEvacuating.autism &&
                        whoLivesHereEntity.specialAssistanceEvacuating.autism.isChecked ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label className="main-title-label"> Autism:</label>
                            {whoLivesHereEntity.specialAssistanceEvacuating.autism
                              .specialConsiderations ? (
                              <Grid className="container-field">
                                {<IoIosList />}
                                <label>
                                  {' '}
                                  {
                                    whoLivesHereEntity.specialAssistanceEvacuating.autism
                                      .specialConsiderations
                                  }
                                </label>
                              </Grid>
                            ) : null}
                          </Grid>
                        ) : null}

                        {whoLivesHereEntity.specialAssistanceEvacuating.foreignLanguageOnly &&
                        whoLivesHereEntity.specialAssistanceEvacuating.foreignLanguageOnly
                          .isChecked ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label className="main-title-label">Foreign language:</label>
                            {whoLivesHereEntity.specialAssistanceEvacuating.foreignLanguageOnly
                              .primaryLanguage ? (
                              <Grid className="container-field">
                                {<IoIosList />}
                                <label>
                                  {
                                    whoLivesHereEntity.specialAssistanceEvacuating
                                      .foreignLanguageOnly.primaryLanguage
                                  }
                                </label>
                              </Grid>
                            ) : null}
                          </Grid>
                        ) : null}

                        {whoLivesHereEntity.specialAssistanceEvacuating
                          .medicalEquipmentNotEasilyTransportable &&
                        whoLivesHereEntity.specialAssistanceEvacuating
                          .medicalEquipmentNotEasilyTransportable.isChecked ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label className="main-title-label">
                              {' '}
                              Requires medical equipment that is not easily transportable:
                            </label>
                            {whoLivesHereEntity.specialAssistanceEvacuating
                              .medicalEquipmentNotEasilyTransportable.description ? (
                              <Grid className="container-field">
                                {<IoIosList />}
                                <label>
                                  {' '}
                                  {
                                    whoLivesHereEntity.specialAssistanceEvacuating
                                      .medicalEquipmentNotEasilyTransportable.description
                                  }
                                </label>
                              </Grid>
                            ) : null}
                          </Grid>
                        ) : null}

                        {whoLivesHereEntity.specialAssistanceEvacuating.otherReason &&
                        whoLivesHereEntity.specialAssistanceEvacuating.otherReason.isChecked &&
                        whoLivesHereEntity.specialAssistanceEvacuating.otherReason.description ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label className="main-title-label">
                              {' '}
                              Other Reason or circumstances we should know:{' '}
                            </label>
                            <Grid className="container-field">
                              {<IoIosList />}
                              <label>
                                {' '}
                                {
                                  whoLivesHereEntity.specialAssistanceEvacuating.otherReason
                                    .description
                                }
                              </label>
                            </Grid>
                          </Grid>
                        ) : null}
                      </Grid>
                    </Grid>
                  ) : null}
                  {whoLivesHereEntity.requiresMedicalEquipment &&
                  whoLivesHereEntity.requiresMedicalEquipment.isChecked ? (
                    <Grid>
                      {whoLivesHereEntity.requiresMedicalEquipment &&
                      whoLivesHereEntity.requiresMedicalEquipment.isChecked ? (
                        <Grid>
                          <label className="main-title-label">Requires Medical Equipment: </label>{' '}
                          <label>Yes</label>
                        </Grid>
                      ) : null}
                      <Grid className="container-field">
                        {whoLivesHereEntity.requiresMedicalEquipment.walkerCane ? (
                          <Grid>
                            {' '}
                            {<IoMdCheckboxOutline />}
                            <label>Walker/Cane</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.requiresMedicalEquipment.standardWheelchair ? (
                          <Grid>
                            {' '}
                            {<IoMdCheckboxOutline />}
                            <label>Standard Wheelchair</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.requiresMedicalEquipment.motorizedWheelchair ? (
                          <Grid>
                            {' '}
                            {<IoMdCheckboxOutline />}
                            <label>Motorized Wheelchair</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.requiresMedicalEquipment
                          .oxygenConcentratorOrCylinder ? (
                          <Grid>
                            {' '}
                            {<IoMdCheckboxOutline />}
                            <label>Oxygen concentrator or cylinder</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.requiresMedicalEquipment.ventilator ? (
                          <Grid>
                            {' '}
                            {<IoMdCheckboxOutline />}
                            <label>Ventilator</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.requiresMedicalEquipment.suctionMachine ? (
                          <Grid>
                            {' '}
                            {<IoMdCheckboxOutline />}
                            <label>Suction Machine</label>{' '}
                          </Grid>
                        ) : null}
                        {whoLivesHereEntity.requiresMedicalEquipment.other ? (
                          <Grid>
                            {<IoMdCheckboxOutline />}
                            <label> Other :</label>
                            <Grid className="container-field">
                              {<IoIosList />}
                              <label> {whoLivesHereEntity.requiresMedicalEquipment.other}</label>
                            </Grid>
                          </Grid>
                        ) : null}
                      </Grid>
                    </Grid>
                  ) : null}
                  {whoLivesHereEntity.requiresMedication?.isChecked ? (
                    <Grid>
                      <label className="main-title-label">This person takes medication: </label>
                      <label>Yes</label>
                      {medicationDescriptionList.length > 0 ? (
                        <Grid className="container-field">
                          <Grid>
                            {medicationDescriptionList.map((medication, idx) => (
                              <Grid style={{ paddingBottom: '.5rem' }} key={`${medication}${idx}`}>
                                {<IoIosList />}
                                <label> {medication}</label>
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      ) : null}
                    </Grid>
                  ) : null}
                  {whoLivesHereEntity.requiresMedicationIfEvacuated &&
                  whoLivesHereEntity.requiresMedicationIfEvacuated.isChecked ? (
                    <Grid>
                      {whoLivesHereEntity.requiresMedicationIfEvacuated &&
                      whoLivesHereEntity.requiresMedicationIfEvacuated.isChecked ? (
                        <Grid>
                          <label className="main-title-label">
                            Requires medications that should be brought with this person if
                            evacuated:{' '}
                          </label>
                          <label>Yes</label>
                        </Grid>
                      ) : null}
                      <Grid className="container-field">
                        {whoLivesHereEntity.requiresMedicationIfEvacuated.location ? (
                          <Grid>
                            {medLocations.length > 0
                              ? medLocations.map((location, idx) => (
                                  <Grid
                                    style={{ paddingBottom: '.5rem' }}
                                    key={`${location}${idx}`}
                                  >
                                    {<IoIosList />}
                                    <label> {location}</label>
                                  </Grid>
                                ))
                              : null}
                          </Grid>
                        ) : null}
                      </Grid>
                    </Grid>
                  ) : null}

                  {whoLivesHereEntity.primaryCarePhysician &&
                  (whoLivesHereEntity.primaryCarePhysician.name !== null ||
                    whoLivesHereEntity.primaryCarePhysician.phoneNumber !== null) ? (
                    <Grid container>
                      <Grid className="container-field">
                        {whoLivesHereEntity.primaryCarePhysician ? (
                          <Grid>
                            <label className="main-title-label">Primary Care Physician: </label>
                          </Grid>
                        ) : null}
                        <Grid className="container-field">
                          {whoLivesHereEntity.primaryCarePhysician.name ? (
                            <Grid>
                              <label> Name: {whoLivesHereEntity.primaryCarePhysician.name}</label>
                            </Grid>
                          ) : null}
                          {whoLivesHereEntity.primaryCarePhysician.phoneNumber ? (
                            <Grid>
                              <a
                                href={'tel:' + whoLivesHereEntity.primaryCarePhysician.phoneNumber}
                              >
                                {' '}
                                Phone Number: {whoLivesHereEntity.primaryCarePhysician.phoneNumber}
                              </a>
                            </Grid>
                          ) : null}
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}

                  {whoLivesHereEntity.additionalInformation ? (
                    <Grid>
                      {whoLivesHereEntity.additionalInformation ? (
                        <Grid>
                          <label className="main-title-label">
                            Any additional specific information concerning this individual that may
                            assist in any emergency response at this location?
                          </label>
                        </Grid>
                      ) : null}
                      <Grid className="container-field">
                        {<IoIosList />}
                        <label> {whoLivesHereEntity.additionalInformation}</label>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default WhoLivesHereItem
